// extracted by mini-css-extract-plugin
export var background = "style-module--background--T0hiH";
export var cover = "style-module--cover--7EOQJ";